'use es6';

import Raven from 'Raven';
import I18n from 'I18n';
import devLogger from 'react-utils/devLogger';
import { upgradeProductToDefaultDuration } from 'self-service-api/constants/Trials';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { startTrial } from 'ui-addon-upgrades/_core/common/api/startTrial';
import wrapWithErrorMonitoring from 'ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring';
import { TEMPORARY_REMOTE_TOOLS } from 'self-service-api/constants/UpgradeProducts';
export var activateTrial = wrapWithErrorMonitoring('activateTrial', function (upgradeData) {
  var trialId = upgradeData.trialId,
      upgradeProduct = upgradeData.upgradeProduct,
      source = upgradeData.source; // Default to 14-day trials if no default specified

  var defaultDurationInDays = upgradeProductToDefaultDuration[upgradeProduct] || 14;
  var endDate = I18n.moment().add(defaultDurationInDays, 'days').valueOf();
  return startTrial(trialId, endDate, source).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('trialActivationInteraction', Object.assign({
      //Temporary override for remote tools so it is not treated as a trial activation success / QL
      action: upgradeProduct === TEMPORARY_REMOTE_TOOLS ? 'remote tools activation succeeded' : 'activation succeeded'
    }, upgradeData));
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'activation failed'
    }, upgradeData));
    devLogger.warn({
      message: e,
      key: 'TrialActivationButton'
    });
    Raven.captureMessage('Trial activation failed', {
      extra: {
        error: e
      }
    });
    throw e;
  });
});